import React, { useRef, lazy } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { ScrollReveal } from './ScrollReveal';
export const Service = () => {
  const ref = useRef(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start end', 'end start']
  });
  const yImage = useTransform(scrollYProgress, [0, 1], ['0%', '10%']);
  const yText = useTransform(scrollYProgress, [0, 1], ['0%', '-10%']);
  const points = ['une évaluation complète du tatouage et de la peau', 'un plan de traitement personnalisé', "l'utilisation du laser picoseconde et du Q-Switched", 'un suivi rigoureux pour soutenir la cicatrisation', 'un accueil professionnel, sérieux et bienveillant'];
  return <section ref={ref} id="service" className="py-32 md:py-48 bg-brand-dark overflow-hidden" data-id="element-147">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12" data-id="element-148">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-24" data-id="element-149">
          {/* Dominant Image Content (Left) */}
          <motion.div style={{
          y: yImage
        }} className="w-full lg:w-[55%] relative h-[60vh] lg:h-[85vh]" data-id="element-150">
            <ScrollReveal clipReveal="left" duration={1.5} className="h-full w-full" data-id="element-151">
              <img src="https://cdn.magicpatterns.com/uploads/tunERiVhYWHGBKBfMUodbr/IMG_2775-PROOF-THOMAS-MASOTTI.jpg" alt="Portrait du praticien spécialiste en détatouage laser chez Dispel Your Tattoo à Martigny" className="w-full h-full object-cover grayscale-[20%]" loading="lazy" data-id="element-152" />
            </ScrollReveal>
          </motion.div>

          {/* Text Content (Right) */}
          <motion.div style={{
          y: yText
        }} className="w-full lg:w-[45%]" data-id="element-153">
            <ScrollReveal blur scale duration={1.2} data-id="element-154">
              <h2 className="text-5xl md:text-6xl lg:text-7xl font-black text-brand-light mb-8 tracking-tighter leading-[1.05] text-balance" data-id="element-155">
                Service de Détatouage en Valais
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={0.2} blur data-id="element-156">
              <h3 className="text-xl md:text-2xl font-medium text-brand-gray mb-14 tracking-tight" data-id="element-157">
                Un Espace Entièrement Consacré au Laser
              </h3>
            </ScrollReveal>

            <div className="space-y-8 mb-16" data-id="element-158">
              {points.map((point, index) => <div key={index} className="flex items-start space-x-6" data-id="element-159">
                  <motion.div initial={{
                scaleX: 0
              }} whileInView={{
                scaleX: 1
              }} viewport={{
                once: true,
                margin: '-100px'
              }} transition={{
                duration: 0.8,
                delay: 0.3 + index * 0.1,
                ease: [0.16, 1, 0.3, 1]
              }} className="w-8 h-[1px] bg-brand-light/30 mt-3 shrink-0 origin-left" data-id="element-160" />
                  <ScrollReveal delay={0.4 + index * 0.1} blur direction="none" distance={0} data-id="element-161">
                    <p className="text-lg md:text-xl text-brand-light font-light leading-snug" data-id="element-162">
                      {point}
                    </p>
                  </ScrollReveal>
                </div>)}
            </div>

            <ScrollReveal delay={0.8} blur data-id="element-163">
              <p className="text-xl text-brand-gray/80 font-light leading-relaxed" data-id="element-164">
                Que vous souhaitiez éclaircir un tatouage pour un cover-up ou
                l'effacer totalement, vous recevrez un accompagnement clair,
                honnête et adapté à vos objectifs.
              </p>
            </ScrollReveal>
          </motion.div>
        </div>
      </div>
    </section>;
};